import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import Button from "../../../../modules/commons/Button";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";

export const tableConfigDetailHadiah = {
  withQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "kodeHadiah",
      label: "Kode Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "namaHadiah",
      label: "Nama Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "categoryHadiah",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        customBodyRender: (value) => {
          return !value ? 1 : value;
        },
        sort: false,
      },
    },
    {
      name: "satuan",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "giftBarcode",
      label: "QR Code",
      options: {
        sort: false,
      },
    },
  ],
  withoutQR: (changeValue, deleteRow) => [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "kodeHadiah",
      label: "Kode Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "namaHadiah",
      label: "Nama Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "categoryHadiah",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "satuan",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "actQTY",
      label: "Act Qty",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              id="input_act_qty"
              name="actQTY"
              box="number"
              value={val}
              onValueChange={({ value }) => {
                changeValue(rowIndex, "actQTY", value);
                changeValue(
                  rowIndex,
                  "diffQty",
                  Number(value) - (rowData[4] || 0),
                );
              }}
            />
          );
        },
      },
    },
    {
      name: "diffQty",
      label: "Diff Qty",
      options: {
        sort: false,
        customBodyRender: (val, { rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              id="input_act_qty"
              name="diffQty"
              box="number"
              readOnly
              value={val}
              onChange={() => {}}
            />
          );
        },
      },
    },
    {
      name: "keterangan",
      label: "Keterangan",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              id="input_act_qty"
              name="keterangan"
              value={val}
              onChange={({ target }) =>
                changeValue(rowIndex, "keterangan", target.value)
              }
            />
          );
        },
      },
    },
    {
      name: "isSaved",
      label: "Aksi",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex }) => {
          return (
            <FlexView style={{ gap: "15px" }}>
              {val ? (
                <Button
                  className="btnAct"
                  onClick={(e) => {
                    e.preventDefault();
                    changeValue(rowIndex, "isSaved", false);
                  }}
                >
                  <i
                    className="fa fa-pencil-alt"
                    style={{
                      fontSize: 20,
                      color: "red",
                    }}
                  />
                </Button>
              ) : (
                <Button
                  className="btnAct"
                  onClick={(e) => {
                    e.preventDefault();
                    changeValue(rowIndex, "isSaved", true);
                  }}
                >
                  <i
                    className="fa fa-save"
                    style={{
                      fontSize: 20,
                      color: "red",
                    }}
                  />
                </Button>
              )}
              <Button
                className="btnAct"
                onClick={(e) => {
                  e.preventDefault();
                  deleteRow(rowIndex, "dataTable");
                }}
              >
                <i
                  className="fa fa-times-circle"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            </FlexView>
          );
        },
      },
    },
  ],
};

export const tableConfigResolveHadiah = {
  withQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "giftCode.kodeHadiah",
      label: "Kode Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "giftCode.nameHadiah",
      label: "Nama Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "giftCode.categoryDTO.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "giftCode.categoryDTO.qty",
      label: "Qty",
      options: {
        sort: false,
        customBodyRender: (val) => {
          return val || 1;
        },
      },
    },
    {
      name: "giftCode.satuanDTO.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "giftBarcode",
      label: "QR Code",
      options: {
        sort: false,
      },
    },
    {
      name: "giftExist",
      label: "Status",
      options: {
        sort: false,
        customBodyRender: (val) => {
          return val ? "DITEMUKAN" : "TIDAK DITEMUKAN";
        },
      },
    },
    {
      name: "userId.name",
      label: "User",
      options: {
        sort: false,
      },
    },
  ],
  withoutQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "giftCode.kodeHadiah",
      label: "Kode Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "giftCode.nameHadiah",
      label: "Nama Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "giftCode.categoryDTO.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        sort: false,
        customBodyRender: (val) => {
          return val || 0;
        },
      },
    },
    {
      name: "giftCode.satuanDTO.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "actualQty",
      label: "Act Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "diffQty",
      label: "Diff Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "note",
      label: "Keterangan",
      options: {
        sort: false,
      },
    },
    {
      name: "userId.name",
      label: "User",
      options: {
        sort: false,
      },
    },
  ],
};

export const tableConfigGiftPartKelebihan = (
  ddlGift = [],
  onChange,
  dataKelebihan,
  changeValue,
  deleteRow,
  dataKekurangan,
) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{rowNumber}</>;
      },
    },
  },
  {
    name: "item.kodeHadiah",
    label: "Kode Hadiah",
    options: {
      sort: false,
    },
  },
  {
    name: "item.nameHadiah",
    label: "Nama Hadiah",
    options: {
      sort: false,
      customBodyRender: (value, tableMeta) => {
        const rowIndex = tableMeta.rowIndex;
        const currentRow = dataKelebihan?.listDataTanpaQR?.[rowIndex];
        const isSaved = currentRow?.isSaved;
        const textError = dataKelebihan?.errorsTanpaQR?.[rowIndex]?.code;
        const nonQrList = ddlGift.filter((opt) => {
          if (opt.qrHadiah !== true) return true;
        });

        const selectedKelebihan =
          dataKelebihan?.listDataTanpaQR?.map(
            (item) => item?.item?.kodeHadiah,
          ) || [];

        const selectedKekurangan =
          dataKekurangan?.map((item) => item?.item?.kodeHadiah) || [];

        const allSelected = [...selectedKelebihan, ...selectedKekurangan];
        const currentKode = currentRow?.item?.kodeHadiah;

        const filteredOptions = nonQrList.filter((opt) => {
          if (opt.value === currentKode) return true;
          return !allSelected.includes(opt.value);
        });

        const val = currentKode
          ? {
              value: currentKode,
              label: currentRow?.item?.nameHadiah,
            }
          : null;

        return isSaved ? (
          val?.label || "-"
        ) : (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SimpleDDL
              id={`ddl_part_${rowIndex}`}
              containerclassname="margin-bottom-none width width-200px"
              name="nameHadiah"
              options={filteredOptions}
              isClearable
              value={val}
              box="search"
              menuPosition="fixed"
              onChange={(opt) => onChange(rowIndex, "nameHadiah", opt)}
            />
            {textError && (
              <span
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "4px",
                }}
              >
                {textError}
              </span>
            )}
          </div>
        );
      },
    },
  },
  {
    name: "item.categoryHadiah",
    label: "Kategori",
    options: {
      sort: false,
    },
  },
  {
    name: "systemQty",
    label: "Qty",
    options: {
      sort: false,
      customBodyRender: (val) => {
        return val || 0;
      },
    },
  },
  {
    name: "item.satuanHadiah",
    label: "Satuan",
    options: {
      sort: false,
    },
  },
  {
    name: "diffQty",
    label: "Diff Qty",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = dataKelebihan?.listDataTanpaQR?.[rowIndex]?.isSaved;
        const textError = dataKelebihan?.errorsTanpaQR?.[rowIndex]?.diffQty;

        if (isSaved) return val ?? 0;

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SimpleInput
              id="input_act_qty"
              name="diffQty"
              containerclassname="margin-bottom-none width width-80px"
              box="onlyNumber"
              value={val ?? 0}
              onChange={(e) =>
                onChange(rowIndex, "diffQty", Number(e.target.value || 0))
              }
            />
            {textError && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {textError}
              </span>
            )}
          </div>
        );
      },
    },
  },
  {
    name: "notes",
    label: "Keterangan",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = dataKelebihan?.listDataTanpaQR?.[rowIndex]?.isSaved;
        const textError = dataKelebihan?.errorsTanpaQR?.[rowIndex]?.notes;
        if (isSaved) {
          return val;
        }
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SimpleInput
              id="input_note"
              name="notes"
              containerclassname="margin-bottom-none width width-200px"
              value={val}
              onChange={({ target }) =>
                onChange(rowIndex, "notes", target.value)
              }
            />
            {textError && (
              <span
                style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
              >
                {textError}
              </span>
            )}
          </div>
        );
      },
    },
  },
  {
    name: "isSaved",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        return (
          <FlexView style={{ gap: "15px" }}>
            {val ? (
              <Button
                className="btnAct"
                onClick={(e) => {
                  e.preventDefault();
                  if (typeof changeValue === "function") {
                    changeValue(rowIndex, "isSaved", false);
                  }
                }}
              >
                <i
                  className="fa fa-pencil-alt"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            ) : (
              <Button
                className="btnAct"
                onClick={(e) => {
                  e.preventDefault();
                  if (typeof changeValue === "function") {
                    changeValue(rowIndex, "isSaved", true);
                  }
                }}
              >
                <i
                  className="fa fa-save"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            )}

            <Button
              className="btnAct"
              onClick={(e) => {
                e.preventDefault();
                if (typeof deleteRow === "function") {
                  deleteRow(rowIndex);
                }
              }}
            >
              <i
                className="fa fa-times-circle"
                style={{
                  fontSize: 20,
                  color: "red",
                }}
              />
            </Button>
          </FlexView>
        );
      },
    },
  },
];

export const tableConfigGiftKekurangan = {
  withQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "giftCode.kodeHadiah",
      label: "Kode Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "giftCode.nameHadiah",
      label: "Nama Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "giftCode.categoryDTO.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "giftCode.satuanDTO.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "giftBarcode",
      label: "QR Code",
      options: {
        sort: false,
      },
    },
  ],
  withoutQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "item.kodeHadiah",
      label: "Kode Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "item.nameHadiah",
      label: "Nama Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "item.categoryDTO.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "systemQty",
      label: "Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "item.satuanDTO.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "differenceQty",
      label: "Diff Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "note",
      label: "Keterangan",
      options: {
        sort: false,
      },
    },
  ],
};
